import { LabelColors } from '@aibees/elephant/types/label';

export const useLabelColor = (colors: LabelColors[]) => {
  return colors.find((i) => i.selected)?.hexCode;
};
